export default {
  title: 'AIRPORT - SHARED TIME AVAILABILITY',
  items: {
    AirportStart: {
      label: 'Start Time',
      type: 'string',
      unit: 'time (e.g. 8:00am)'
    },
    AirportEnd: {
      label: 'End Time',
      type: 'string',
      unit: 'time (e.g. 11:00pm)'
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/shared-time-availability.js